import React, { Component } from 'react';
import xtend from 'xtend';

import Channel from './types/Channel';
import Checkbox from './types/Checkbox';
import FallbackImageSelect from './types/FallbackImageSelect';
import LegalInput from './types/LegalInput';
import MetadataSelect from './types/MetadataSelect';
// import AbsoluteDateInput from './types/AbsoluteDateInput'
import RelativeDateInput from './types/RelativeDateInput';
import SelectInput from './types/SelectInput';
import Slates from './types/Slates';
import Template from './types/Template';
import TextInput from './types/TextInput';
import TwitterFeed from './types/TwitterFeed';
import CategorySelect from './types/CategorySelect'
import DependencyMultiSelect from './types/DependencyMultiSelect'
import NumberSpinner from './types/NumberSpinner'
import AbsoluteDateInput from './types/AbsoluteDateInput';

export default function PreferenceRenderUtil (WrappedComponent) {

    function Utils (props) {
        return {
            /**
             * Renders preferences based on the Preference's inputType
             *
             * @method
             * @param  {String} preferenceName      Key Name of Preference (via schema)
             * @param  {String|Bool|Null} value     The value of the preference
             * @param  {Object} pref                The raw Preference schema setting group
             * @param  {Function} changeHandler     Sends the key/value to the PreferenceStateUtil
             * @param  {Object} context             The Context of the preference (if any)
             * @param  {Array} data                 The user's assets from the Global Media Library
             * @param {Object} otherPreferences     The preferences for the active tab including edits
             * @return {Component}                  react component
             */
            renderPreference: function (preferenceName, value, pref,
                changeHandler, context, data, otherPreferences) {

                switch (pref.inputType) {
                    case "assets":
                        return <Slates
                            value={value}
                            assets={data}
                            preferenceName={preferenceName}
                            storeEdits={changeHandler}/>;

                    case "checkbox":
                        return <Checkbox
                            value={value}
                            storeEdits={changeHandler}
                            preferenceName={preferenceName}
                            otherPreferences={otherPreferences}
                        />

                    case "modal":
                        return <FallbackImageSelect
                            value={value}
                            actions={props.actions}
                            assets={props.assets}
                            preferenceName={preferenceName}
                            storeEdits={changeHandler}/>;

                    case "legal":
                        return <LegalInput
                            value={value}
                            preferenceName={preferenceName}
                            storeEdits={changeHandler}/>;

                    case "select":
                        return <SelectInput
                            value={value}
                            options={pref.options}
                            preferenceName={preferenceName}
                            storeEdits={changeHandler}/>;

                    case "text":
                    case "email":
                        return <TextInput
                            preferenceName={preferenceName}
                            value={value}
                            storeEdits={changeHandler}/>;

                    case "twitter":
                        return <TwitterFeed
                            value={value}
                            context={context}
                            preferenceName={preferenceName}
                            storeEdits={changeHandler}/>;

                    case "channel":
                        return <Channel
                            value={value}
                            channels={data}
                            preferenceName={preferenceName}
                            storeEdits={changeHandler}/>;

                    case "relative-date":
                        return <RelativeDateInput
                            value={value}
                            options={pref.options}
                            preferenceName={preferenceName}
                            storeEdits={changeHandler}
                            otherPreferences={otherPreferences}
                        />
                    case "absolute-date":
                        return <AbsoluteDateInput
                            value={value}
                            options={pref}
                            preferenceName={preferenceName}
                            storeEdits={changeHandler}
                            otherPreferences={otherPreferences}
                        />
                    case 'category-select':
                        return <CategorySelect
                            value={value}
                            // categories={props.categories}
                            preferenceName={preferenceName}
                            storeEdits={changeHandler}
                            clearFull={false}
                            useHidden={true}
                            useName={true}
                        />
                    case "metadata":
                        const { keywords, categories, locations } = props;
                        return <MetadataSelect
                            value={value}
                            keywords={keywords.data.clientKeywords}
                            categories={categories}
                            locations={locations}
                            preferenceName={preferenceName}
                            storeEdits={changeHandler}/>;
                    case 'dependency-multi-select':
                        return <DependencyMultiSelect
                            pref={pref}
                            value={value}
                            preferenceName={preferenceName}
                            storeEdits={changeHandler}
                            allPreferences={props.preference}
                            activeTab={props.activeTab}
                            edits={props.edits}
                        />
                    case 'number':
                        return <NumberSpinner
                            min={pref.min}
                            max={pref.max}
                            preferenceName={preferenceName}
                            value={value}
                            storeEdits={changeHandler}
                        />
                    default:
                        return <div>default</div>
                }
            },

            renderTemplate: function (edits, template, index) {
                const isSelected = edits != null ?
                    edits == template.value :
                    false;

                return <Template
                    stateUtils={props.stateUtils}
                    index={index}
                    isSelected={isSelected}
                    template={template}/>;
            }
        };
    }

    class PreferenceRenderWrapper extends Component {
        constructor (props) {
            super(props);
            this.utils = Utils(props);
        }

        render () {
            return React.createElement(
                WrappedComponent,
                xtend({
                    renderUtils: this.utils
                }, this.props),
                []
            );
        }
    }

    return PreferenceRenderWrapper;
}
